<template>
    <v-card elevation="0">
        <v-card-title class="tit tit--sm primary--text pt-0 px-0" v-if="title"> {{ title }} </v-card-title>
        <v-card-text class="pa-0">
            <slot />
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null },
    },
};
</script>

<style></style>
